<template>
  <pt-integral-task class="pt-integral-task__page"></pt-integral-task>
</template>

<script>
import PtIntegralTask from 'cps/integral-mall-manage/pt-integral-task/withData'
export default {
  name: 'pt-integral-task__view',
  components: {
    'pt-integral-task': PtIntegralTask
  }
}
</script>
